/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    MilestoneResponse,
    MilestoneResponseFromJSON,
    MilestoneResponseFromJSONTyped,
    MilestoneResponseToJSON,
    OWLogCategory,
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWRewardMaxType,
    OWRewardMaxTypeFromJSON,
    OWRewardMaxTypeFromJSONTyped,
    OWRewardMaxTypeToJSON,
    OWRewardMode,
    OWRewardModeFromJSON,
    OWRewardModeFromJSONTyped,
    OWRewardModeToJSON,
    OWUserStat,
    OWUserStatFromJSON,
    OWUserStatFromJSONTyped,
    OWUserStatToJSON,
    QuestReset,
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Collection contains the rewards that can be claimed.
 * @export
 * @interface OWReward
 */
export interface OWReward {
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    game?: string;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof OWReward
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof OWReward
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and processes event logs in BE) or not.
     * @type {boolean}
     * @memberof OWReward
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof OWReward
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof OWReward
     */
    questCompleteNotificationMessage?: string;
    /**
     * The maximum amount of XP that can be claimed for the 1hr time quest.
     * @type {number}
     * @memberof OWReward
     */
    rewardMax?: number;
    /**
     * 
     * @type {OWRewardMaxType}
     * @memberof OWReward
     */
    rewardMaxType?: OWRewardMaxType;
    /**
     * 
     * @type {QuestReset}
     * @memberof OWReward
     */
    questReset: QuestReset;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWReward
     */
    rewardCategory: OWLogCategory;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    eventType: string;
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof OWReward
     */
    target: number;
    /**
     * 
     * @type {Array<MilestoneResponse>}
     * @memberof OWReward
     */
    milestones?: Array<MilestoneResponse>;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof OWReward
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof OWReward
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    endAt?: number;
    /**
     * Ref to the challenge of this quest (only for challenge quests).
     * @type {string}
     * @memberof OWReward
     */
    challenge?: string;
    /**
     * 
     * @type {OWUserStat}
     * @memberof OWReward
     */
    userStat?: OWUserStat;
    /**
     * If the TIME quest is available for all supported games that are not in our database (OWGames).
     * @type {boolean}
     * @memberof OWReward
     */
    onAllSupportedGames?: boolean;
    /**
     * 
     * @type {OWRewardMode}
     * @memberof OWReward
     */
    mode?: OWRewardMode;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    updatedAt: number;
}

export function OWRewardFromJSON(json: any): OWReward {
    return OWRewardFromJSONTyped(json, false);
}

export function OWRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWReward {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'game': !exists(json, 'game') ? undefined : json['game'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': !exists(json, 'showQuestCompleteNotification') ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': !exists(json, 'questCompleteNotificationMessage') ? undefined : json['questCompleteNotificationMessage'],
        'rewardMax': !exists(json, 'rewardMax') ? undefined : json['rewardMax'],
        'rewardMaxType': !exists(json, 'rewardMaxType') ? undefined : OWRewardMaxTypeFromJSON(json['rewardMaxType']),
        'questReset': QuestResetFromJSON(json['questReset']),
        'rewardCategory': OWLogCategoryFromJSON(json['rewardCategory']),
        'eventType': json['eventType'],
        'target': json['target'],
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(MilestoneResponseFromJSON)),
        'rewardConfigs': !exists(json, 'rewardConfigs') ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'isSponsored': !exists(json, 'isSponsored') ? undefined : json['isSponsored'],
        'sponsorName': !exists(json, 'sponsorName') ? undefined : json['sponsorName'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
        'rewardImage': !exists(json, 'rewardImage') ? undefined : json['rewardImage'],
        'startAt': !exists(json, 'startAt') ? undefined : json['startAt'],
        'endAt': !exists(json, 'endAt') ? undefined : json['endAt'],
        'challenge': !exists(json, 'challenge') ? undefined : json['challenge'],
        'userStat': !exists(json, 'userStat') ? undefined : OWUserStatFromJSON(json['userStat']),
        'onAllSupportedGames': !exists(json, 'onAllSupportedGames') ? undefined : json['onAllSupportedGames'],
        'mode': !exists(json, 'mode') ? undefined : OWRewardModeFromJSON(json['mode']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function OWRewardToJSON(value?: OWReward | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'game': value.game,
        'name': value.name,
        'description': value.description,
        'isActive': value.isActive,
        'showQuestCompleteNotification': value.showQuestCompleteNotification,
        'questCompleteNotificationMessage': value.questCompleteNotificationMessage,
        'rewardMax': value.rewardMax,
        'rewardMaxType': OWRewardMaxTypeToJSON(value.rewardMaxType),
        'questReset': QuestResetToJSON(value.questReset),
        'rewardCategory': OWLogCategoryToJSON(value.rewardCategory),
        'eventType': value.eventType,
        'target': value.target,
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(MilestoneResponseToJSON)),
        'rewardConfigs': value.rewardConfigs === undefined ? undefined : ((value.rewardConfigs as Array<any>).map(RewardConfigResponseToJSON)),
        'isSponsored': value.isSponsored,
        'sponsorName': value.sponsorName,
        'logo': value.logo,
        'color': value.color,
        'externalUrl': value.externalUrl,
        'rewardImage': value.rewardImage,
        'startAt': value.startAt,
        'endAt': value.endAt,
        'challenge': value.challenge,
        'userStat': OWUserStatToJSON(value.userStat),
        'onAllSupportedGames': value.onAllSupportedGames,
        'mode': OWRewardModeToJSON(value.mode),
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}


